import React from 'react';
import { InputBase, Box, Paper, IconButton, Icon } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useStyles } from './searchbar.styles';
import { Sort } from './sort';
import { get } from 'global/lib/lodash';
import { Loader } from '../../styles';
import clsx from 'clsx';

export default function SearchBar(props) {
  const classes = useStyles();
  const { sort, loading } = props;

  const onSearchInputChange = (event) => {
    if (event.target.value) {
      props.changeSearch(event.target.value);
    } else {
      props.changeSearch('');
    }
  };

  const hasClear = get(props, 'onClear');

  return (
    <Box displayPrint="none" className={clsx(classes.container, props.containerStyle, props.classes && props.classes)}>
      {props.SearchIcon && <div style={{ position: 'absolute', zIndex: 100 }}>
        {props.SearchIcon}
      </div>}
      <Paper className={classes.search}>
        <div className={props.sidebar ? classes.searchIconSidebar : classes.searchIcon}>
          {!props.SearchIcon && <SearchIcon />}
        </div>
        <InputBase
          placeholder="Search..."
          id="searchInput"
          value={props.searchString}
          onChange={onSearchInputChange}
          classes={{
            root: classes.inputRoot,
            input: props.sidebar ? classes.inputInputSidebar : classes.inputInput,
          }}
        />
        {hasClear && props.searchString && (
          <IconButton onClick={props.onClear} className={classes.clearIcon} size="large">
            {loading ? <Loader size={16} /> : <Icon>clear</Icon>}
          </IconButton>
        )}
      </Paper>
      {sort && <Sort {...sort} />}
    </Box>
  );
}
